import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-social-login',
  standalone: true,
  imports: [],
  templateUrl: './social-login.component.html',
  styleUrl: './social-login.component.scss'
})
export class SocialLoginComponent {
  @Output() signInWithGoogle: EventEmitter<any> = new EventEmitter<any>();
  @Output() signInWithMicrosoft: EventEmitter<any> = new EventEmitter<any>();

  createWrapper() {
    const w: any = window;
    const googleLoginWrapper = document.createElement('div');
    googleLoginWrapper.style.display = 'none';
    googleLoginWrapper.classList.add('custom-google-button');
    document.body.appendChild(googleLoginWrapper);
    w.google.accounts.id.renderButton(googleLoginWrapper, {
      type: 'icon',
      width: '200',
    });

    const googleLoginWrapperButton = googleLoginWrapper.querySelector(
      'div[role=button]'
    ) as HTMLElement;

    return {
      click: () => {
        googleLoginWrapperButton?.click();
      },
    };
  }

  handleGoogleLogin(): void {
    this.signInWithGoogle.emit(this.createWrapper());
  }

  handleMicrosoftLogin(): void {
    this.signInWithMicrosoft.emit(this.createWrapper());
  }
}
